export const CHAPTER_ACTIONS = {
  SET_STATE: "chapter/setState",
  GET_CHAPTER: "chapter/getChapter",
  GET_CHAPTER_BY_ID: "chapter/getChapterById",
  CREATE_CHAPTER: "chapter/createChapter",
  UPDATE_CHAPTER: "chapter/updateChapter",
  UPDATE_CHAPTER_PASSWORD: "chapter/updateChapterPassword",
  DELETE_CHAPTER: "chapter/deleteChapter",
};
